import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Tabs,
  Tab,
  Breadcrumb,
  ButtonGroup,
  Row,
  Spinner,
  Container,
  Col,
  Card,
} from "react-bootstrap";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik } from "formik";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import { useToasts } from "react-toast-notifications";
import { useMutation, useLazyQuery, useApolloClient } from "@apollo/client";
import {
  faBoxOpen,
  faEdit,
  faImages,
  faPlus,
  faTimes,
  faTrash,
  faTrashAlt,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import {
  COLOR_APP,
  COLOR_BORDER_IMAGE_B0X,
  COLOR_TEXT,
  K_LOCAL_STORAGE_SHOP_SETTING_DATA,
  S3_URL,
  VANESSA_SHOP_ID,
} from "../../../constants";
import { v4 as uuidv4 } from "uuid";
import NumberFormat from "react-number-format";
import {
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  CREATE_PRODUCT_AND_STOCKS,
} from "../../../graphql/product/mutation";
import { GET_PRODUCTS } from "../../../graphql/product/query";
import {
  CREATE_STOCK,
  UPDATE_STOCK,
  UPDATE_STOCK_V2,
} from "../../../graphql/stock/mutation";
import { GET_PRESIGN_URL } from "../../../graphql/presignUrl/query";
import { GET_OPTION_VALUES } from "../../../graphql/optionValue/query";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { GET_STOCK } from "../../../graphql/stock/query";
import { imageRender } from "../../../helpers";
import { MdDelete, MdOutlineAdd } from "react-icons/md";
import TextEditor from "../../../components/CKEditor";
import { FaCheck, FaUpload } from "react-icons/fa";

import UplaodManyImages from "./UploadManyImages";
import { GET_CATEGORYS } from "../../../graphql/category/query";
import { GET_BRANDS } from "../../../graphql/brand/query";
import { CREATE_BRAND } from "../../../graphql/brand/mutation";
import { CREATE_SUB_CATEGORY, GET_SUB_CATEGORIES } from "../../../graphql/subCategory";
import { CREATE_CATEGORY } from "../../../graphql/category/mutation";
import CategorySortField, {
  useUsedCategorySorts,
} from "../../categorys/CategorySortField";
import { GET_UNITS } from "../../../graphql/unit/query";
import { CREATE_UNIT } from "../../../graphql/unit/mutation";

//* ລາຍການຮູບທີ່ໃຊ້ໄດ້ ບໍ່ຊ້ຳ ຮັກສາລຳດັບເດີມ
const uniqueImages = (images) => [
  ...new Set(
    (images ?? []).filter(
      (img) => typeof img === "string" && img.trim() !== "" && img !== "undefined",
    ),
  ),
];

function ProductAdd() {
  const { height, width } = useWindowDimensions();
  const { addToast } = useToasts();
  const { history, match } = useReactRouter();

  //* Base platform is Sale page: the product form shows the minimum fields.
  //* CF-only fields (ລະຫັດ CF / ຮູບແບບລະຫັດ) appear ONLY when the shop has the
  //* "LIVE" system enabled (LIVE = CF). A shop with no systems is treated as
  //* Sale-page-only, so CF fields stay hidden and CF code is not required.
  const _shopData = (() => {
    try {
      return JSON.parse(localStorage.getItem("SHOP_DATA")) || {};
    } catch (e) {
      return {};
    }
  })();
  const isCF = (_shopData?.systems || []).includes("LIVE");
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [editMode, setEditMode] = useState(false);
  const [duplicateMode, setDuplicateMode] = useState(false);
  const [productData, setProductData] = useState();
  const [productsData, setProductsData] = useState();
  const [options, setOptions] = useState([]);
  const [isSelectedOptions, setIsSelectedOptions] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsWhenGen, setSelectedOptionsWhenGen] = useState([]);
  const [stockPriceLak, setPriceLak] = useState();
  const [stockOriginPriceLak, setOriginPriceLak] = useState();
  const [stockAmount, setAmount] = useState();
  const [dataWillDelete, setDataWillDelete] = useState([]);
  const [isProductAmount, setIsProductAmount] = useState(false);
  // const [isProductPrice, setIsProductPrice] = useState(false);

  const [currency, setCurrency] = useState("ກີບ");
  //* ສ່ວນຫຼຸດເປັນເປີເຊັນ (PERCENT) ຫຼື ເປັນຈຳນວນເງິນ (AMOUNT)
  const [reductionType, setReductionType] = useState("PERCENT");
  const [isCodeGenEmpty, setIsCodeGenEmpty] = useState(false);
  const [codeGen, setCodeGen] = useState("");
  const [key, setKey] = useState("not_option");
  const [codeGenNotOption, setCodeGenNotOption] = useState("");
  const [isCodeGenNotOption, setIsCodeGenNotOption] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [genCodeType, setGenCodeType] = useState("ONE_CODE");
  const [startCodeGen, setStartCodeGen] = useState();
  const [endCodeGen, setEndCodeGen] = useState();
  const [codeGens, setCodeGens] = useState([]);
  const [productTitle, setProductTitle] = useState("");
  const [note, setNote] = useState("");
  const [productTitleEmpty, setProductTitleEmpty] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [properties, setProperties] = useState([]);
  // console.log("properties:: ", properties)
  const [showDetail, setShowDetail] = useState(false);
  //add many images
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedNewImages, setSelectedNewImage] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [msgError, setMsgError] = useState(null);
  const [error, setError] = useState(false);
  const [errorPropertie, setErrorPropertie] = useState(false);
  const inputRef = useRef();

  const [fileDescription, setFileDescription] = useState(null);
  const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"));

  const [imagePreview, setImagePreview] = useState(null);
  const [imageLoading, setImageLoading] = useState(0);
  const [fileNameDescription, setFileNameDescription] = useState("");
  const [editorData, setEditorData] = useState("");
  const [entries, setEntries] = useState([]);
  const [categoryDatas, setCategoryDatas] = useState([]);
  const [shopId, setShopId] = useState();
  const [categoryId, setCategoryId] = useState();
  //* ແບຣນ (ຂໍ້ມູນຊຸດດຽວກັນກັບ POS) — "" = ບໍ່ມີແບຣນ
  const [brandId, setBrandId] = useState("");
  //* ເພີ່ມແບຣນໄດ້ຈາກໜ້ານີ້ເລີຍ ບໍ່ຕ້ອງເຂົ້າໄປໜ້າ BrandLists
  const [showAddBrandModal, setShowAddBrandModal] = useState(false);
  const [newBrandName, setNewBrandName] = useState("");
  //* ປະເພດຍ່ອຍ ເປີດສະເພາະຮ້ານ Vanessa ກ່ອນ — ຮ້ານອື່ນບໍ່ເຫັນ ແລະ ບໍ່ສົ່ງຄ່ານີ້ໄປແກ້ຂໍ້ມູນເດີມ
  const canUseSubCategory = VANESSA_SHOP_ID.includes(localStorage.getItem("SHOP"));
  const [subCategoryId, setSubCategoryId] = useState("");
  const [showAddSubCategoryModal, setShowAddSubCategoryModal] = useState(false);
  const [newSubCategoryName, setNewSubCategoryName] = useState("");
  const [categoriesName, setCategoriesName] = useState();
  //* ເພີ່ມປະເພດສິນຄ້າໄດ້ຈາກໜ້ານີ້ເລີຍ ບໍ່ຕ້ອງເຂົ້າໄປໜ້າ CategoryLists
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryNote, setNewCategoryNote] = useState("");
  const [newCategorySort, setNewCategorySort] = useState("");
  //* ຫົວໜ່ວຍ — ເລືອກຈາກລາຍການ ຫຼື ເພີ່ມໃໝ່ໄດ້ຈາກໜ້ານີ້ເລີຍ
  const [unitDatas, setUnitDatas] = useState([]);
  const [showAddUnitModal, setShowAddUnitModal] = useState(false);
  const [newUnitName, setNewUnitName] = useState("");
  //* ຄ່າຂອງ stock ທີ່ຟອມນີ້ບໍ່ມີຊ່ອງໃຫ້ແກ້ — ສົ່ງກັບຄືນຕອນອັບເດດ
  const [keepStockFields, setKeepStockFields] = useState({});
  //* ເປີດຂາຍເທິງ SalePage / ສິນຄ້າແນະນຳ (ຄືກັບ fourB-pos)
  //* ສິນຄ້າໃໝ່ເປີດຂາຍເທິງ SalePage ເປັນຄ່າເລີ່ມຕົ້ນ — ຄືກັບ default ຂອງ stockModel
  const [isUsingSalePage, setIsUsingSalePage] = useState(true);
  const [isRecommended, setIsRecommended] = useState(false);

  const [createStock, { loading: createStockLoading }] =
    useMutation(CREATE_STOCK);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [updateStockV2, { loading: updateStockV2Loading }] =
    useMutation(UPDATE_STOCK_V2);
  const [createProductAndStocks, { loading: createProductAndStocksLoading }] =
    useMutation(CREATE_PRODUCT_AND_STOCKS);
  const [updateProduct] = useMutation(UPDATE_PRODUCT);
  const [getProducts, { data: productDatas }] = useLazyQuery(GET_PRODUCTS, {
    fetchPolicy: "cache-and-network",
  });
  const [getOptionValues, { data: optionValueDatas }] = useLazyQuery(
    GET_OPTION_VALUES,
    { fetchPolicy: "cache-and-network" },
  );
  //* ຂໍ presigned URL ແບບແຍກ ສຳລັບຮູບປະກອບ / ຮູບລາຍລະອຽດ
  //* ຫ້າມໃຊ້ getPresignUrl: useEffect ທີ່ຟັງ presignUrlData ຈະເອົາຮູບຫຼັກ (file) ໄປອັບທັບ
  //* URL ຂອງຮູບອື່ນ, ແລະ ເອີ້ນ lazy query ດຽວກັນພ້ອມກັນຫຼາຍເທື່ອ ຜົນອາດສັບກັນ
  const apolloClient = useApolloClient();
  const requestPresignUrl = async (name) => {
    const { data } = await apolloClient.query({
      query: GET_PRESIGN_URL,
      variables: { name },
      fetchPolicy: "no-cache",
    });
    return data?.preSignedUrl?.url;
  };
  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);
  const [getBrandData, { data: loadBrandData }] = useLazyQuery(GET_BRANDS, {
    fetchPolicy: "cache-and-network",
  });
  const [createBrand, { loading: createBrandLoading }] = useMutation(CREATE_BRAND);
  const [getSubCategoryData, { data: loadSubCategoryData }] = useLazyQuery(GET_SUB_CATEGORIES, {
    fetchPolicy: "cache-and-network",
  });
  const [createSubCategory, { loading: createSubCategoryLoading }] = useMutation(CREATE_SUB_CATEGORY);
  const [getCategoryData, { data: loadCategoryData }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "cache-and-network" },
  );
  const [createCategory, { loading: createCategoryLoading }] =
    useMutation(CREATE_CATEGORY);
  //* ເລກລຳດັບການສະແດງທີ່ປະເພດອື່ນໃຊ້ແລ້ວ — ໂຫຼດຕອນເປີດ modal ເພີ່ມປະເພດ
  const {
    usedSorts,
    isTaken,
    loading: loadingSorts,
  } = useUsedCategorySorts(showAddCategoryModal, shopId);
  const [getUnitData, { data: loadUnitData }] = useLazyQuery(GET_UNITS, {
    fetchPolicy: "cache-and-network",
  });
  const [createUnit, { loading: createUnitLoading }] = useMutation(CREATE_UNIT);

  const [getStock, { data: stockDataDetail }] = useLazyQuery(GET_STOCK);
  let productId = match.params.productId;

  useEffect(() => {
    if (shopData) {
      setShopId(shopData?.id);
    }
  }, [shopData]);
  useEffect(() => {
    if (loadCategoryData) {
      setCategoryDatas(loadCategoryData?.categories?.data);
    }
  }, [loadCategoryData]);

  useEffect(() => {
    if (loadUnitData) {
      setUnitDatas(loadUnitData?.units?.data ?? []);
    }
  }, [loadUnitData]);

  useEffect(() => {
    getStock({
      variables: {
        where: {
          id: productId,
        },
      },
    });
  }, [productId]);
  //* ໂຫຼດຂໍ້ມູນ stock ມາຕື່ມໃສ່ຟອມຕອນແກ້ໄຂ — ຟອມດຽວກັບຕອນເພີ່ມ
  useEffect(() => {
    const _stock = stockDataDetail?.stock;
    if (!_stock) return;

    //* image ເປັນໄດ້ທັງ string ແລະ array
    const _image = Array.isArray(_stock?.image)
      ? _stock?.image?.[0] || ""
      : _stock?.image || "";

    setProductTitle(_stock?.name);
    setAmount(_stock?.amount);
    setPriceLak(_stock?.price);
    setOriginPriceLak(_stock?.originPrice);
    setCurrency(_stock?.currency ?? "ກີບ");
    setNote(_stock?.note ?? "");
    setFileName(_image);
    setCodeGenNotOption(_stock?.cfMessage ?? "");
    setCategoryId(_stock?.category?.id);
    setCategoriesName(_stock?.category?.name ?? _stock?.categoryName);
    setSubCategoryId(_stock?.subCategory?.id ?? "");
    setBrandId(_stock?.brand?.id ?? "");
    setReductionType(_stock?.reductionType ?? "PERCENT");
    setProperties(_stock?.properties ?? []);
    setEntries(
      (_stock?.descriptions ?? []).map((item) => ({
        title: item?.title ?? "",
        image: item?.image ?? "",
      })),
    );
    //* ຮູບປະກອບ = image[1...] (ຮູບເພີ່ມເຕີມຈາກ POS) + containImages (ຂໍ້ມູນເກົ່າຂອງ 4b-live)
    //* ບັນທຶກແລ້ວຈະຍ້າຍໄປເກັບໃນ image ທັງໝົດ (ເບິ່ງ buildStockImages)
    const _extraImages = uniqueImages([
      ...(Array.isArray(_stock?.image) ? _stock.image.slice(1) : []),
      ...(_stock?.containImages ?? []),
    ]).filter((img) => img !== _image);
    setSelectedNewImage(_extraImages);
    setSelectedImages(_extraImages.map((_n) => imageRender(_n)));
    //* ໜ້ານີ້ແກ້ໄດ້ເທື່ອລະ 1 ສິນຄ້າ ຈຶ່ງບໍ່ເປີດແທັບ Option
    setIsSelectedOptions(false);
    //* ຟິວທີ່ຟອມນີ້ບໍ່ມີ — ຖືໄວ້ເພື່ອສົ່ງກັບຄືນຕອນອັບເດດ ບໍ່ໃຫ້ຄ່າເດີມຫາຍ
    setKeepStockFields({
      amountAll: _stock?.amountAll ?? 0,
      amountSale: _stock?.amountSale ?? 0,
      sort: _stock?.sort,
      isUsingSalePage: _stock?.isUsingSalePage,
    });
    setIsUsingSalePage(Boolean(_stock?.isUsingSalePage));
    setIsRecommended(Boolean(_stock?.isUsingSalePage && _stock?.isRecommended));
    setProductData({
      ...(_stock?.product ?? {}),
      id: _stock?.product?.id,
      image: _image,
      unit: _stock?.unit ?? "",
      reduction: _stock?.reduction ?? "",
    });
  }, [stockDataDetail]);

  useEffect(() => {
    if (!history.location.state) history.goBack();
    setEditMode(history.location.state.editMode);
    setDuplicateMode(history.location.state.duplicateMode);
    getOptionValue();
    getShopProducts();
  }, []);

  useEffect(() => {
    // console.log("presignUrlData: ", presignUrlData);
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  // useEffect
  useEffect(() => {
    fetchCategoryData();
    fetchUnitData();
    fetchBrandData();
  }, [shopId]);

  //* ຄ່າພິເສດຂອງ option ສຸດທ້າຍ ໃຊ້ເປີດ modal ເພີ່ມປະເພດສິນຄ້າ / ຫົວໜ່ວຍ
  const ADD_CATEGORY_OPTION = "__ADD_CATEGORY__";
  const ADD_UNIT_OPTION = "__ADD_UNIT__";
  const ADD_BRAND_OPTION = "__ADD_BRAND__";
  const ADD_SUB_CATEGORY_OPTION = "__ADD_SUB_CATEGORY__";

  const fetchSubCategoryData = () =>
    getSubCategoryData({
      variables: { where: { category: categoryId }, orderBy: "createdAt_ASC", limit: 200 },
    });

  useEffect(() => {
    if (canUseSubCategory && categoryId) fetchSubCategoryData();
  }, [canUseSubCategory, categoryId]);

  //* ຜົນເກົ່າຂອງປະເພດອື່ນອາດຍັງຄ້າງລະຫວ່າງໂຫຼດ ຈຶ່ງກອງຕາມປະເພດທີ່ເລືອກຢູ່
  const subCategoryOptions = (loadSubCategoryData?.subCategories?.data ?? []).filter(
    (s) => s?.category?.id === categoryId,
  );

  const onSelectSubCategory = (e) => {
    const _value = e.target.value;
    if (_value === ADD_SUB_CATEGORY_OPTION) {
      //* ບໍ່ແມ່ນປະເພດຍ່ອຍຈິງ — ເປີດ modal ແລ້ວປະຄ່າທີ່ເລືອກໄວ້ຄືເກົ່າ
      setShowAddSubCategoryModal(true);
      return;
    }
    setSubCategoryId(_value);
  };

  const onCloseAddSubCategoryModal = () => {
    setShowAddSubCategoryModal(false);
    setNewSubCategoryName("");
  };

  //* ສ້າງປະເພດຍ່ອຍໃໝ່ພາຍໃຕ້ປະເພດທີ່ເລືອກ ແລ້ວເລືອກໃຫ້ເລີຍ
  const onCreateSubCategory = async () => {
    if (createSubCategoryLoading) return;
    const _name = newSubCategoryName?.trim();
    if (!_name) {
      addToast("ກະລຸນາປ້ອນຊື່ປະເພດຍ່ອຍ!", { appearance: "error", autoDismiss: true });
      return;
    }
    try {
      const response = await createSubCategory({
        variables: { data: { name: _name, category: categoryId } },
      });
      const _id = response?.data?.createSubCategory?.id;
      if (!_id) throw new Error("CREATE_SUB_CATEGORY_FAILED");
      await fetchSubCategoryData();
      setSubCategoryId(_id);
      onCloseAddSubCategoryModal();
      addToast("ເພີ່ມປະເພດຍ່ອຍສໍາເລັດ", { appearance: "success", autoDismiss: true });
    } catch (error) {
      console.log("error creating sub category: ", error);
      addToast(
        error?.message?.includes("SUB_CATEGORY_ALREADY_EXIST")
          ? "ປະເພດຍ່ອຍນີ້ມີຢູ່ແລ້ວ ກະລຸນາເລືອກຈາກລາຍການ"
          : "ເພີ່ມປະເພດຍ່ອຍບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ",
        { appearance: "error", autoDismiss: true },
      );
    }
  };

  //* ແບຣນທີ່ເລືອກໄດ້: ທີ່ເຊື່ອມກັບປະເພດທີ່ເລືອກ + ທີ່ບໍ່ເຊື່ອມປະເພດ (+ ອັນທີ່ສິນຄ້າໃຊ້ຢູ່ ບໍ່ໃຫ້ຫາຍ)
  const brandOptions = (loadBrandData?.brands?.data ?? []).filter(
    (b) => !b?.category?.id || b?.category?.id === categoryId || b?.id === brandId,
  );

  // select category data
  const onSelectCategories = (e) => {
    let _id = e.target.value;
    if (_id === ADD_CATEGORY_OPTION) {
      //* ບໍ່ແມ່ນປະເພດຈິງ — ເປີດ modal ແລ້ວປະຄ່າທີ່ເລືອກໄວ້ຄືເກົ່າ
      setShowAddCategoryModal(true);
      return;
    }
    const prepateCategory = categoryDatas.find((cat) => cat.id === _id);
    setCategoryId(prepateCategory?.id);
    setCategoriesName(prepateCategory?.name);
    //* ປະເພດຍ່ອຍຢູ່ພາຍໃຕ້ປະເພດຫຼັກ — ປ່ຽນປະເພດແລ້ວຕ້ອງເລືອກໃໝ່
    setSubCategoryId("");
  };

  const onCloseAddCategoryModal = () => {
    setShowAddCategoryModal(false);
    setNewCategoryName("");
    setNewCategoryNote("");
    setNewCategorySort("");
  };

  //* ສ້າງປະເພດສິນຄ້າໃໝ່ແລ້ວເລືອກໃຫ້ເລີຍ
  const onCreateCategory = async () => {
    if (createCategoryLoading) return;
    if (!newCategoryName?.trim()) {
      addToast("ກະລຸນາປ້ອນຊື່ປະເພດສິນຄ້າ!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    try {
      const _name = newCategoryName.trim();
      const response = await createCategory({
        variables: {
          data: {
            name: _name,
            note: newCategoryNote ?? "",
            //* ຫວ່າງ → null (ບໍ່ກຳນົດລຳດັບ)
            sort: newCategorySort === "" ? null : parseInt(newCategorySort, 10),
            shop: shopId,
          },
        },
      });
      if (response?.data?.createCategory?.message !== "CREATED_SUCCESS") {
        throw new Error("CREATE_CATEGORY_FAILED");
      }
      //* createCategory ຄືນມາແຕ່ message ບໍ່ມີ id — ຈຶ່ງຫາຕົວທີ່ຫາກໍສ້າງຈາກ
      //* ລາຍການທີ່ດຶງມາໃໝ່ ໂດຍທຽບກັບ id ຊຸດເກົ່າ ແລ້ວເລືອກໃຫ້ເລີຍ
      const _previousIds = new Set((categoryDatas ?? []).map((cat) => cat?.id));
      const _refetched = await fetchCategoryData();
      const _freshCategories = _refetched?.data?.categories?.data ?? [];
      const _created =
        _freshCategories.find((cat) => cat?.id && !_previousIds.has(cat?.id)) ??
        _freshCategories.find((cat) => cat?.name === _name);
      if (_created?.id) {
        setCategoryId(_created.id);
        setCategoriesName(_created.name);
        setSubCategoryId("");
      }
      onCloseAddCategoryModal();
      addToast("ເພີ່ມປະເພດສິນຄ້າສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log("error creating category: ", error);
      addToast("ເພີ່ມປະເພດສິນຄ້າບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const fetchBrandData = () =>
    getBrandData({
      variables: {
        where: { shop: shopId, isDeleted: false },
        orderBy: "createdAt_DESC",
        limit: 200,
      },
    });

  const onSelectBrand = (e) => {
    const _value = e.target.value;
    if (_value === ADD_BRAND_OPTION) {
      //* ບໍ່ແມ່ນແບຣນຈິງ — ເປີດ modal ແລ້ວປະຄ່າທີ່ເລືອກໄວ້ຄືເກົ່າ
      setShowAddBrandModal(true);
      return;
    }
    setBrandId(_value);
  };

  const onCloseAddBrandModal = () => {
    setShowAddBrandModal(false);
    setNewBrandName("");
  };

  //* ສ້າງແບຣນໃໝ່ແລ້ວເລືອກໃຫ້ເລີຍ
  //* ຜູກກັບປະເພດທີ່ເລືອກຢູ່ ຄືກົດຂອງ brandOptions — ບໍ່ໄດ້ເລືອກປະເພດ = ໃຊ້ໄດ້ທຸກປະເພດ
  const onCreateBrand = async () => {
    if (createBrandLoading) return;
    const _name = newBrandName?.trim();
    if (!_name) {
      addToast("ກະລຸນາປ້ອນຊື່ແບຣນ!", { appearance: "error", autoDismiss: true });
      return;
    }
    try {
      const response = await createBrand({
        variables: {
          data: { name: _name, shop: shopId, category: categoryId || null },
        },
      });
      const _id = response?.data?.createBrand?.id;
      if (!_id) throw new Error("CREATE_BRAND_FAILED");
      await fetchBrandData();
      setBrandId(_id);
      onCloseAddBrandModal();
      addToast("ເພີ່ມແບຣນສໍາເລັດ", { appearance: "success", autoDismiss: true });
    } catch (error) {
      console.log("error creating brand: ", error);
      addToast(
        error?.message?.includes("BRAND_ALREADY_EXIST")
          ? "ແບຣນນີ້ມີຢູ່ແລ້ວ ກະລຸນາເລືອກຈາກລາຍການ"
          : "ເພີ່ມແບຣນບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ",
        { appearance: "error", autoDismiss: true },
      );
    }
  };

  const fetchCategoryData = async () => {
    try {
      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      //* ຄືນຜົນລັບໃຫ້ຜູ້ເອີ້ນນຳໃຊ້ໄດ້ (ຜູ້ເອີ້ນເກົ່າບໍ່ໄດ້ໃຊ້ ຈຶ່ງບໍ່ກະທົບ)
      return await getCategoryData({
        variables: {
          where: _where,
          //* ເລກລຳດັບການສະແດງນ້ອຍຂຶ້ນກ່ອນ, ອັນທີ່ບໍ່ກຳນົດຕໍ່ທ້າຍຕາມລຳດັບເດີມ
          orderBy: "sort_ASC",
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const fetchUnitData = async () => {
    try {
      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      return await getUnitData({
        variables: {
          where: _where,
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  // select unit data — ເກັບເປັນ "ຊື່" ຄືເກົ່າ ເພື່ອບໍ່ໃຫ້ກະທົບ stock.unit
  const onSelectUnit = (e, setFieldValue) => {
    const _value = e.target.value;
    if (_value === ADD_UNIT_OPTION) {
      //* ບໍ່ແມ່ນຫົວໜ່ວຍຈິງ — ເປີດ modal ແລ້ວປະຄ່າທີ່ເລືອກໄວ້ຄືເກົ່າ
      setShowAddUnitModal(true);
      return;
    }
    setFieldValue("unit", _value);
  };

  const onCloseAddUnitModal = () => {
    setShowAddUnitModal(false);
    setNewUnitName("");
  };

  //* ສ້າງຫົວໜ່ວຍໃໝ່ແລ້ວເລືອກໃຫ້ເລີຍ
  const onCreateUnit = async (setFieldValue) => {
    if (createUnitLoading) return;
    if (!newUnitName?.trim()) {
      addToast("ກະລຸນາປ້ອນຊື່ຫົວໜ່ວຍ!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    try {
      const _name = newUnitName.trim();
      const response = await createUnit({
        variables: {
          data: {
            name: _name,
            shop: shopId,
          },
        },
      });
      if (response?.data?.createUnit?.message !== "CREATED_SUCCESS") {
        throw new Error("CREATE_UNIT_FAILED");
      }
      await fetchUnitData();
      setFieldValue("unit", _name);
      onCloseAddUnitModal();
      addToast("ເພີ່ມຫົວໜ່ວຍສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log("error creating unit: ", error);
      addToast("ເພີ່ມຫົວໜ່ວຍບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };

  const getShopProducts = async () => {
    const SHOP_ID = await localStorage.getItem("SHOP");
    await getProducts({
      variables: {
        where: {
          isDeleted: false,
          shop: SHOP_ID,
        },
      },
    });
    // const products = (await DataStore.query(Product, Predicates.ALL)).filter(c => c?.shop?.id == SHOP_ID);
    // setProductsData(products);
  };

  useEffect(() => {
    // console.log("productDatas: ", productDatas?.products)
    if (productDatas?.products?.data?.length > 0) {
      setProductsData(productDatas?.products?.data);
    }
  }, [productDatas]);

  useEffect(() => {
    // console.log("optionValueDatas: ", optionValueDatas)
    if (optionValueDatas?.optionValues?.data) {
      let groupOption = _.groupBy(optionValueDatas?.optionValues?.data, "name");
      let _newDataOption = [];
      for (let [_optionName, values] of Object.entries(groupOption)) {
        let _values = [];
        for (var i = 0; i < values.length; i++) {
          _values.push({
            id: values[i].id,
            name: values[i].name,
            value: values[i].value,
          });
        }
        _newDataOption.push({
          name: _optionName,
          values: _values,
        });
      }
      setOptions(_newDataOption);
      // console.log({_newDataOption})
    }
  }, [optionValueDatas]);

  //* ໂຄ້ດເກົ່າທີ່ອ່ານ history.location.state.data.stock[0] ຖືກຍ້າຍໄປໃຊ້ຜົນຈາກ
  //* GET_STOCK ແທນແລ້ວ (ເບິ່ງ useEffect ຂອງ stockDataDetail ດ້ານເທິງ)

  const getOptionValue = async () => {
    const SHOP_ID = await localStorage.getItem("SHOP");
    // const _shopOptions = (await DataStore.query(OptionValue)).filter(c => c?.shop?.id == SHOP_ID);

    await getOptionValues({
      variables: {
        where: {
          isDeleted: false,
          shop: SHOP_ID,
        },
      },
    });
  };

  const _createProduct = async (values) => {
    try {
      if (createProductAndStocksLoading) return;
      const SHOP_ID = await localStorage.getItem("SHOP");
      if (isSelectedOptions && selectedOptionsWhenGen?.length === 0) {
        addToast("ກະລຸນາປ້ອນຂໍ້ມູນຂອງສິນຄ້າໃຫ້ຄົບຖ້ວນ!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (!productTitle) {
        addToast("ກະລຸນາປ້ອນຊື່ສິນຄ້າ!", {
          appearance: "error",
          autoDismiss: true,
        });
      }
      if (!isSelectedOptions && (!stockPriceLak || !stockAmount)) {
        addToast("ກະລຸນາປ້ອນຂໍ້ມູນຂອງສິນຄ້າໃຫ້ຄົບຖ້ວນ!", {
          appearance: "error",
          autoDismiss: true,
        });

        if (!stockAmount || (stockAmount === 0 && genCodeType === "ONE_CODE")) {
          setIsProductAmount(true);
        }
        return;
      }
      //* ຊ່ອງສ່ວນຫຼຸດສະແດງເປັນ 1,000 ຈຶ່ງຕ້ອງເອົາຄອມມາອອກກ່ອນແປງເປັນຕົວເລກ
      const _reduction =
        parseInt((values?.reduction ?? 0).toString().replace(/,/g, "")) || 0;
      //* ບໍ່ບລັອກຕອນພິມ — ມາເຕືອນຕອນບັນທຶກແທນ
      if (reductionType === "PERCENT" && _reduction > 100) {
        addToast("ສ່ວນຫຼຸດເປັນເປີເຊັນຕ້ອງບໍ່ເກີນ 100!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      setIsLoading(true);
      const NewRemainingEntries = entries.map((image) => {
        const { imagePreview, ...remainingEntries } = image;
        return remainingEntries;
      });
      let _stocks = [];
      if (isSelectedOptions) {
        if (selectedOptionsWhenGen.length > 0) {
          for (var i = 0; i < selectedOptionsWhenGen.length; i++) {
            if (selectedOptionsWhenGen[i].value.length > 0) {
              for (var j = 0; j < selectedOptionsWhenGen[i].value.length; j++) {
                if (selectedOptionsWhenGen[i]?.value[j]?.amount > 0) {
                  _stocks.push({
                    price: parseFloat(
                      (selectedOptionsWhenGen[i]?.value[j]?.price || 0)
                        .toString()
                        .replace(/,/g, ""),
                    ),
                    originPrice: parseFloat(
                      (selectedOptionsWhenGen[i]?.value[j]?.originPrice || 0)
                        .toString()
                        .replace(/,/g, ""),
                    ),
                    amount: parseInt(
                      selectedOptionsWhenGen[i]?.value[j]?.amount ?? 0,
                    ),
                    image: fileName,
                    currency: currency,
                    name: productTitle ?? "",
                    note: note ?? "",
                    unit: values.unit ?? "",
                    cfMessage:
                      selectedOptionsWhenGen[i]?.value[j]?.cfMessage ?? "",
                    optionValues: [
                      selectedOptionsWhenGen[i]?.value[j]?.key?.id,
                      selectedOptionsWhenGen[i]?.value[j]?.id,
                    ],
                    containImages: selectedNewImages,
                    properties: properties,
                    descriptions: NewRemainingEntries,
                    category: categoryId,
                    categoryName: categoriesName,
                    brand: brandId || null,
                    reduction: _reduction,
                    reductionType: reductionType,
                  });
                }
              }
            } else {
              if (selectedOptionsWhenGen[i]?.amount > 0) {
                _stocks.push({
                  price: parseFloat(
                    (selectedOptionsWhenGen[i]?.price || 0)
                      .toString()
                      .replace(/,/g, ""),
                  ),
                  originPrice: parseFloat(
                    (selectedOptionsWhenGen[i]?.originPrice || 0)
                      .toString()
                      .replace(/,/g, ""),
                  ),
                  amount: parseInt(selectedOptionsWhenGen[i]?.amount ?? 0),
                  image: fileName,
                  currency: currency,
                  name: productTitle ?? "",
                  note: note ?? "",
                  unit: values.unit ?? "",
                  cfMessage: selectedOptionsWhenGen[i]?.cfMessage ?? "",
                  optionValues: [selectedOptionsWhenGen[i]?.key?.id],
                  containImages: selectedNewImages,
                  properties: properties,
                  descriptions: NewRemainingEntries,
                  category: categoryId,
                  categoryName: categoriesName,
                  brand: brandId || null,
                  reduction: _reduction,
                  reductionType: reductionType,
                });
              }
            }
          }
        }
      } else {
        //* CF code ບໍ່ບັງຄັບທັງຕອນເພີ່ມ ແລະ ແກ້ໄຂ — ບໍ່ປ້ອນກໍບັນທຶກເປັນ cfMessage ຫວ່າງ
        if (stockAmount <= 0) {
          addToast("ກະລຸນາປ້ອນຈຳນວນ!", {
            appearance: "error",
            autoDismiss: true,
          });
          return;
        }
        // setIsProductPrice(false);
        setIsProductAmount(false);
        setIsCodeGenNotOption(false);
        if (genCodeType === "ONE_CODE") {
          _stocks.push({
            price: parseFloat(
              stockPriceLak ? stockPriceLak.toString().replace(/,/g, "") : 0,
            ),
            originPrice: parseFloat(
              stockOriginPriceLak
                ? stockOriginPriceLak.toString().replace(/,/g, "")
                : 0,
            ),
            amount: parseInt(stockAmount ?? 0),
            image: fileName,
            currency: currency,
            name: productTitle ?? "",
            note: note ?? "",
            unit: values.unit ?? "",
            cfMessage: codeGenNotOption ?? "",
            containImages: selectedNewImages,
            properties: properties,
            descriptions: NewRemainingEntries,
            category: categoryId,
            categoryName: categoriesName,
            brand: brandId || null,
            reduction: _reduction,
            reductionType: reductionType,
          });
        } else {
          for (var i = 0; i < codeGens.length; i++) {
            _stocks.push({
              price: parseFloat(
                codeGens[i].price
                  ? codeGens[i].price.toString().replace(/,/g, "")
                  : 0,
              ),
              originPrice: parseFloat(
                codeGens[i].originPrice
                  ? codeGens[i].originPrice.toString().replace(/,/g, "")
                  : 0,
              ),
              amount: parseInt(codeGens[i].amount ?? 0),
              image: fileName,
              currency: currency,
              name: codeGens[i].name ?? productTitle ?? "",
              unit: values.unit ?? "",
              note: note ?? "",
              cfMessage: codeGens[i].cfMessage ?? "",
              containImages: selectedNewImages,
              properties: properties,
              descriptions: NewRemainingEntries,
              category: categoryId,
              categoryName: categoriesName,
              brand: brandId || null,
              reduction: _reduction,
              reductionType: reductionType,
            });
          }
        }
      }

      if (_stocks.length > 0) {
        await createProductAndStocks({
          variables: {
            data: {
              product: {
                ...values,
                title: productTitle,
                currency: currency,
                image: fileName,
                reduction: _reduction,
                reductionType: reductionType,
              },
              stocks: _stocks.map((_stock) => ({
                ..._stock,
                image: buildStockImages(_stock.image),
                //* ຮູບປະກອບຢູ່ໃນ image ແລ້ວ — ບໍ່ເກັບຊ້ຳ
                containImages: [],
                ...(canUseSubCategory ? { subCategory: subCategoryId || null } : {}),
                isUsingSalePage,
                isRecommended: isUsingSalePage && isRecommended,
              })),
            },

            where: {
              shop: SHOP_ID,
            },
          },
        });
        setIsLoading(false);
        addToast("ເພີ່ມສິນຄ້າສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        history.goBack();
      } else {
        setIsLoading(false);
        addToast("ກະລຸນາເພີ່ມຈຳນວນໃສ່ໃຫ້ກັບສະຕ໊ອກກ່ອນ", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (err) {
      setIsLoading(false);
      console.log("error creating todo:", err);
      //* ບໍ່ໃຫ້ລົ້ມແບບງຽບໆ — ຖ້າສ້າງບໍ່ສຳເລັດຕ້ອງບອກຜູ້ໃຊ້
      addToast(
        err?.message?.includes("CF_MESSAGE_ALREADY_EXISTS")
          ? "ລະຫັດ CF ນີ້ມີຢູ່ໃນຮ້ານແລ້ວ ກະລຸນາປ່ຽນລະຫັດ CF"
          : "ເພີ່ມສິນຄ້າບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ",
        {
          appearance: "error",
          autoDismiss: true,
        },
      );
    }
  };

  const checkProductName = async (values, productId) => {
    let status = false;
    if (productsData && productsData.length > 0) {
      if (productId) {
        for (var i = 0; i < productsData.length; i++) {
          if (
            productsData[i].title === values.title &&
            productsData[i].id != productId
          ) {
            i = productsData.length;
            status = true;
          }
        }
      } else {
        for (var i = 0; i < productsData.length; i++) {
          if (productsData[i].title === values.title) {
            i = productsData.length;
            status = true;
          }
        }
      }
    }
    return status;
  };

  //* ແກ້ໄຂສິນຄ້າ 1 ລາຍການ — ໃຊ້ຟອມດຽວກັບຕອນເພີ່ມ ແລ້ວຍິງ updateStockV2
  //* ຄືກັບຕອນແກ້ໃນຕາຕະລາງ (ບໍ່ໄດ້ໃຊ້ updateProduct/updateStock ຊຸດເກົ່າແລ້ວ)
  const _editProduct = async (values) => {
    try {
      if (updateStockV2Loading) return;
      if (!productTitle) {
        addToast("ກະລຸນາປ້ອນຊື່ສິນຄ້າ!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (!stockPriceLak || !stockAmount) {
        addToast("ກະລຸນາປ້ອນຂໍ້ມູນຂອງສິນຄ້າໃຫ້ຄົບຖ້ວນ!", {
          appearance: "error",
          autoDismiss: true,
        });
        if (!stockAmount || stockAmount == 0) {
          setIsProductAmount(true);
        }
        return;
      }
      const _price = parseFloat(
        stockPriceLak ? stockPriceLak.toString().replace(/,/g, "") : 0,
      );
      const _originPrice = parseFloat(
        stockOriginPriceLak
          ? stockOriginPriceLak.toString().replace(/,/g, "")
          : 0,
      );
      if (_price < 0 || _originPrice < 0) {
        addToast("ເງິນບໍ່ສາມາດໃສ່ເຄື່ອງໝາຍລົບໄດ້!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      if (parseInt(stockAmount) < 0) {
        addToast("ຈຳນວນບໍ່ສາມາດໃສ່ເຄື່ອງໝາຍລົບໄດ້!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      //* ຊ່ອງສ່ວນຫຼຸດສະແດງເປັນ 1,000 ຈຶ່ງຕ້ອງເອົາຄອມມາອອກກ່ອນແປງເປັນຕົວເລກ
      const _reduction =
        parseInt((values?.reduction ?? 0).toString().replace(/,/g, "")) || 0;
      if (reductionType === "PERCENT" && _reduction > 100) {
        addToast("ສ່ວນຫຼຸດເປັນເປີເຊັນຕ້ອງບໍ່ເກີນ 100!", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      //* ຕອນແກ້ໄຂ CF code ບໍ່ບັງຄັບ (ຕອນເພີ່ມຍັງບັງຄັບສຳລັບຮ້ານ CF ຄືເກົ່າ)

      setIsLoading(true);
      const NewRemainingEntries = entries.map((image) => {
        const { imagePreview, ...remainingEntries } = image;
        return remainingEntries;
      });

      await updateStockV2({
        variables: {
          data: {
            price: _price,
            originPrice: _originPrice,
            amount: parseInt(stockAmount ?? 0),
            image: buildStockImages(fileName || productData?.image),
            currency: currency,
            name: productTitle ?? "",
            note: note ?? "",
            unit: values.unit ?? "",
            cfMessage: codeGenNotOption ?? "",
            //* ຮູບປະກອບຢູ່ໃນ image ແລ້ວ — ລ້າງ containImages ເກົ່າ ບໍ່ໃຫ້ເກັບຊ້ຳ
            containImages: [],
            properties: properties,
            descriptions: NewRemainingEntries,
            category: categoryId,
            categoryName: categoriesName,
            brand: brandId || null,
            ...(canUseSubCategory ? { subCategory: subCategoryId || null } : {}),
            reduction: _reduction,
            reductionType: reductionType,
            //* ບໍ່ສົ່ງ amountAll: resolver ຖື amountAll ເປັນ "ຈຳນວນທີ່ຈະບວກເພີ່ມ" ($inc)
            //* ຖ້າສົ່ງຄ່າເດີມກັບຄືນ ມັນຈະບວກຊ້ຳ (12 → 24). ປ່ອຍໃຫ້ resolver ຕັ້ງ amount
            //* ຕາມທີ່ພິມ ແລ້ວບວກ amountAll ໃຫ້ເທົ່າສ່ວນຕ່າງເອງ
            //* ຟິວທີ່ຟອມນີ້ບໍ່ມີຊ່ອງໃຫ້ແກ້ — ສົ່ງຄ່າເດີມກັບຄືນ ບໍ່ໃຫ້ຫາຍ
            amountSale: parseInt(keepStockFields?.amountSale ?? 0),
            sort: keepStockFields?.sort,
            isUsingSalePage,
            isRecommended: isUsingSalePage && isRecommended,
          },
          where: {
            id: productId,
          },
        },
      });

      setIsLoading(false);
      addToast("ແກ້ໄຂສິນຄ້າສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
      history.goBack();
    } catch (err) {
      setIsLoading(false);
      console.log("error editing product:", err);
      addToast("ແກ້ໄຂສິນຄ້າບໍ່ສຳເລັດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };
  const _duplicateProduct = async (values) => {
    try {
      const _resultCheckProductName = await checkProductName(values);
      if (!_resultCheckProductName) {
        addToast("ເພີ່ມສິນຄ້າສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        history.goBack();
      } else {
        addToast("ຊື່ຂອງສິນຄ້າຊ້ຳກັນກັບສິນຄ້າທີ່ມີຢູ່ແລ້ວ!", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (err) {
      console.log("error creating todo:", err);
    }
  };

  const handleUpload = async (event) => {
    setImageLoading(0);
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      // console.log("filename: ", filename)
      await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        // console.log("uploadfile: ", uploadfile);
      }
    } catch (error) {
      console.log("Error in onFileUpload: ", error);
    }
  };

  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          borderRadius: 8,
          height: 200,
          width: 200,
        }}
      />
    );
  };

  let sListData = [];
  const onGenOption = async () => {
    if (!productTitle) {
      return addToast("ກະລຸນາປ້ອນຊື່ສິນຄ້າກ່ອນ!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
    //* CF shops must provide the code prefix; Sale-page shops generate options
    //* without a CF prefix (cfMessage comes out empty / option-only).
    if (isCF && !codeGen) {
      setIsCodeGenEmpty(true);
    } else {
      let _sListData = [];
      for (var i = 0; i < selectedOptions.length; i++) {
        _sListData.push(selectedOptions[i].values);
      }
      sListData = [..._sListData];
      let _data = await getGenOption(sListData);
      let _newData = _data.split("||").slice(1);
      let data = [];
      let _code = 1;
      let _codeMain = 1;
      for (var i = 0; i < _newData.length; i++) {
        let values = [];
        let _dataValues = _newData[i].split("&")[1].split(";");
        if (_dataValues && _dataValues.length > 0 && _dataValues[0] != "") {
          for (var j = 0; j < _dataValues.length; j++) {
            let _keyData = JSON.parse(_newData[i].split("&")[0]);
            let _valueData = JSON.parse(_dataValues[j]);
            values.push({
              ..._valueData,
              key: _keyData,
              amount: stockAmount,
              price: stockPriceLak,
              originPrice: stockOriginPriceLak,
              cfMessage: (codeGen + "" + _keyData.value + "" + _valueData.value)
                .trim()
                .replace(/ /g, ""),
            });
            _code++;
          }
        }
        let _keyDataMain = JSON.parse(_newData[i].split("&")[0]);
        data.push({
          id: null,
          key: _keyDataMain,
          amount: stockAmount,
          price: stockPriceLak,
          originPrice: stockOriginPriceLak,
          cfMessage: (codeGen + "" + _keyDataMain.value)
            .trim()
            .replace(/ /g, ""),
          value: values,
        });
        _codeMain++;
      }
      let _selectedOptionsWhenGen = [...selectedOptionsWhenGen];
      _selectedOptionsWhenGen.push(...data);
      setSelectedOptionsWhenGen(_selectedOptionsWhenGen);
      // setSelectedOptions([]);
      setCodeGen("");
    }
  };

  var setData = "";
  const getGenOption = async (sList) => {
    if (sList.length > 0) {
      for (var i = 0; i < sList[0].length; i++) {
        const checkData = sListData[0].filter((item) => item == sList[0][i]);
        if (checkData.length > 0) {
          setData += "||" + JSON.stringify(sList[0][i]) + "&";
        } else {
          setData +=
            JSON.stringify(sList[0][i]) + (i + 1 != sList[0].length ? ";" : "");
        }
        getGenOption(sList.slice(1));
      }
    }
    return setData;
  };

  const onSelectedType = async (e) => {
    setGenCodeType(e?.target?.value);
  };

  const genMutiCode = async () => {
    if (!stockAmount || !productTitle || !codeGenNotOption) {
      if (!stockAmount) setIsProductAmount(true);
      if (!productTitle) setProductTitleEmpty(true);
      if (!codeGenNotOption) setIsCodeGenNotOption(true);
    } else {
      // get setting from localstorage
      let sCodeStartWithO =
        JSON.parse(localStorage.getItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA))
          ?.sCodeStartWithO ?? false;
      let _codeGen = [];
      for (var i = parseInt(startCodeGen); i <= parseInt(endCodeGen); i++) {
        _codeGen.push({
          // cfMessage: codeGenNotOption + "" + i,
          cfMessage:
            // codeGenNotOption + "" +  padV2(i.toString(), endCodeGen.length),
            codeGenNotOption +
            "" +
            (sCodeStartWithO
              ? padV2(i.toString(), endCodeGen.length)
              : pad(i.toString(), endCodeGen.length)),
          name: productTitle ?? "",
          amount: stockAmount ?? "",
          price: stockPriceLak ?? "",
          originPrice: stockOriginPriceLak ?? "",
          originPrice: stockOriginPriceLak ?? "",
        });
      }
      setCodeGens(_codeGen);
    }
  };
  function pad(n, width, z) {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
  function padV2(n, width) {
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join("") + n;
  }

  const _onSelectNewOption = (item, vl) => {
    let _newOption = [...selectedOptions];
    let _optionIndex = _.findIndex(selectedOptions, { name: item?.name });
    if (_optionIndex < 0) {
      _newOption.push({
        name: item?.name,
        values: [{ id: vl?.id, name: vl?.name, value: vl?.value }],
      });
      setSelectedOptions(_newOption);
      return;
    }
    let _vlIndex = _.findIndex(selectedOptions[_optionIndex]?.values, {
      id: vl?.id,
    });
    if (_vlIndex >= 0) {
      // TODO: clear data from option value
      _.remove(_newOption[_optionIndex]?.values, { id: vl?.id });
      // TODO: clear data from option
      if (selectedOptions[_optionIndex]?.values?.length <= 0)
        _.remove(_newOption, { name: item?.name });
      setSelectedOptions(_newOption);
      return;
    }
    if (_optionIndex >= 0) {
      _newOption[_optionIndex].values.push({
        id: vl?.id,
        name: vl?.name,
        value: vl?.value,
      });
      setSelectedOptions(_newOption);
      return;
    }
  };

  const _checkSelectedOptionVal = (val) => {
    let _check = true;
    selectedOptions.map((vl) => {
      const _valIndex = _.findIndex(vl, { id: val?.id });
      if (_valIndex < 0) _check = false;
      return _check;
    });
  };

  const _removeOptionProduct = (item, index, index2) => {
    if (item?.value?.length <= 1) {
      let _data = [...selectedOptionsWhenGen];
      if (_data[index]?.stockId) {
        let _dataWillDelete = [...dataWillDelete, _data[index].stockId];
        setDataWillDelete(_dataWillDelete);
      }
      const _newData = _data.filter((_option) => _option != _data[index]);
      setSelectedOptionsWhenGen(_newData);

      return;
    }
    let _data = [...selectedOptionsWhenGen];
    if (_data[index]?.value[index2]?.stockId) {
      let _dataWillDelete = [
        ...dataWillDelete,
        _data[index].value[index2].stockId,
      ];
      setDataWillDelete(_dataWillDelete);
    }
    const _newData = _data[index].value.filter(
      (_option) => _option != _data[index].value[index2],
    );
    _data[index].value = _newData;
    setSelectedOptionsWhenGen(_data);
  };

  //add list
  const handleAddDetail = () => {
    if (!title && !detail) {
      setErrorPropertie(true);
      return;
    }

    const newPropertiesData = [...properties, { title, detail }];
    setProperties(newPropertiesData);
    setTitle("");
    setDetail("");
    setShowModal(false);
  };

  const handleDelete = (index) => {
    setProperties(properties.filter((_, i) => i !== index));
  };

  //add discroption

  const handleEditorChange = (data) => {
    setEditorData(data);
    setError(false);
  };

  const handleImage = async (event) => {
    setImageLoading(0);
    setError(false);
    try {
      const selectedFile = event.target.files[0];

      setFileDescription(selectedFile);

      const ext = selectedFile.name.split(".").pop();
      const filename = `${uuidv4()}.${ext}`;
      const presignedUrl = await requestPresignUrl(filename);

      setFileNameDescription(filename);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);

      await onFileDescription(presignedUrl, selectedFile);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileDescription = async (url, fileDescription) => {
    try {
      // if (fileDescription && url) {
      const uploadfile = await axios.put(url, fileDescription, {
        headers: {
          "Content-Type": "file/*; image/*",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setImageLoading(percentCompleted);
        },
      });
      console.log("File uploaded successfully:", uploadfile);
      // }
    } catch (error) {
      console.log("ERROR:", error);
    }
  };

  const handleButtonClick = () => {
    if (!editorData && !fileDescription) {
      setError(true);
      return;
    }
    const strippedTitle = editorData.replace(/<[^>]*>/g, ""); // Remove HTML tags
    // console.log("strippedTitle", strippedTitle)
    const newEntry = {
      title: strippedTitle,
      image: fileNameDescription,
      imagePreview: imagePreview,
    };
    setError(false);
    setEntries([...entries, newEntry]);
    setEditorData(""); // Clear the editor after submission
    setFileDescription(null);
    setImagePreview("");
  };

  const handleRemoveCard = (index) => {
    const newEntries = entries.filter((_, i) => i !== index);
    setEntries(newEntries);
  };
  //========== add discription

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleImageSelect = async (event) => {
    try {
      //* ເລືອກໄດ້ຫຼາຍຮູບພ້ອມກັນ (input ມີ multiple)
      const files = Array.from(event.target.files || []);
      //* ລ້າງຄ່າ input ໃຫ້ເລືອກໄຟລ໌ເດີມຊ້ຳໄດ້ອີກ
      event.target.value = "";
      if (files.length === 0) return;

      const remaining = 9 - selectedImages.length;
      if (files.length > remaining) {
        setMsgError(
          `ເລືອກຮູບພາບເພີ່ມເຕີ່ມໄດ້ສູງສຸດ 9 ຮູບ (ເພີ່ມໄດ້ອີກ ${Math.max(remaining, 0)} ຮູບ)`,
        );
        return;
      }

      //* ກວດປະເພດໄຟລ໌ທັງໝົດກ່ອນອັບໂຫຼດ — ບໍ່ໃຫ້ອັບໄປເຄິ່ງໜຶ່ງແລ້ວຄ້າງ
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (files.some((file) => !allowedTypes.includes(file?.type))) {
        setMsgError("ກະລຸນາເລືອກຮູບພາບທີ່ເປັນ png, jpg, jpeg");
        return;
      }

      //* ອັບໂຫຼດພ້ອມກັນ ແລ້ວຕື່ມຕາມລຳດັບທີ່ເລືອກ — ແຕ່ລະຮູບມີ presigned URL ຂອງຕົວເອງ
      const results = await Promise.all(
        files.map(async (file) => {
          try {
            const ext = file.name.split(".").pop();
            const filename = uuidv4() + "." + ext;
            const url = await requestPresignUrl(filename);
            if (!url) return null;
            const ok = await uploadToS3(url, file);
            if (!ok) return null;
            return { filename, preview: URL.createObjectURL(file) };
          } catch (e) {
            console.log("Error uploading image:", e);
            return null;
          }
        }),
      );
      //* ເກັບສະເພາະຮູບທີ່ອັບສຳເລັດ — ບໍ່ໃຫ້ມີຊື່ໄຟລ໌ທີ່ບໍ່ມີຢູ່ຈິງໃນ S3
      const uploaded = results.filter(Boolean);

      setSelectedNewImage((prev) => [...prev, ...uploaded.map((u) => u.filename)]);
      setSelectedImages((prev) => [...prev, ...uploaded.map((u) => u.preview)]);
      setMsgError(
        uploaded.length < files.length
          ? `ອັບໂຫຼດບໍ່ສຳເລັດ ${files.length - uploaded.length} ຮູບ ກະລຸນາລອງໃໝ່`
          : null,
      );
    } catch (error) {
      console.log("Error uploading image:", error);
      setMsgError("Error uploading image");
    }
  };

  const uploadToS3 = async (url, file) => {
    // console.log("url ::", url)
    // console.log("file ::", file)
    try {
      await axios.put(url, file, {
        headers: {
          "Content-Type": "file/*; image/*",
        },
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          setUploadProgress(progress);
        },
      });
      return true;
    } catch (error) {
      console.log("Error uploading to S3:", error);
      return false;
    }
  };

  //* ຮູບຂອງ stock ເກັບໃນ image array ດຽວ ຄືກັບ POS: [ຮູບຫຼັກ, ...ຮູບປະກອບ]
  //* POS ແລະ sale-page ອ່ານຈາກ image ຢູ່ແລ້ວ → ເຫັນຮູບປະກອບຈາກ 4b-live ນຳ
  const buildStockImages = (mainImage) =>
    uniqueImages([mainImage, ...selectedNewImages]);

  const handleImageDelete = (index) => {
    const newImages = [...selectedImages];
    const newImageS3 = [...selectedNewImages];
    newImages.splice(index, 1);
    newImageS3.splice(index, 1);
    setSelectedImages(newImages);
    setSelectedNewImage(newImageS3);
  };

  return (
    <>
      {/* ບໍ່ໃຊ້ AnimationLoading ບັງທັງໜ້າແລ້ວ — ໄປໂຊ spinner ຢູ່ປຸ່ມ "ບັນທຶກ" ແທນ */}
      <div style={{ paddingTop: width > 700 ? 0 : 25 }}>
        <Breadcrumb>
          <Breadcrumb.Item onClick={() => history.goBack(-1)}>
            ຄັງສິນຄ້າ
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {!editMode ? "ເພີ່ມສິນຄ້າ" : "ແກ້ໄຂສິນຄ້າ"}
          </Breadcrumb.Item>
        </Breadcrumb>
        <div
          style={{
            background: "#F9F9F9",
            padding: width > 700 ? 24 : 10,
            borderRadius: 5,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <h3 style={{ color: "#616161" }}>
              {" "}
              <FontAwesomeIcon icon={faBoxOpen} />{" "}
              {!editMode ? "ເພີ່ມສິນຄ້າ" : "ແກ້ໄຂສິນຄ້າ"}
            </h3>
          </div>
          <p
            style={{
              fontSize: 16,
              color: "#616161",
              margin: 0,
              paddingRight: 20,
            }}
            className="text-left"
          >
            ເພີ່ມ ແກ້ໄຂສິນຄ້າເຂົ້າໃນສາງໂດຍການເພີ່ມຮູບພາບ ຊື່ສິນຄ້າ
            ຍອດຄັງຍັງເຫຼືອ ລາຄາເພື່ອກໍານົດສິນຄ້າໃນການຊື້ຂາຍ
          </p>
          <div style={{ height: 20 }} />

          {(!editMode || productData) && (
            <Formik
              //* ຂໍ້ມູນ stock ໂຫຼດມາທີຫຼັງ ຈຶ່ງຕ້ອງໃຫ້ Formik ຕັ້ງຄ່າໃໝ່ຕອນມາຮອດ
              enableReinitialize
              initialValues={{
                // title: productData?.title ? productData?.title : '',
                unit: productData?.unit || "",
                reduction: productData?.reduction ?? "",
              }}
              validate={(values) => {
                // const errors = {};
                // if (!values.title) {
                //     errors.title = 'ກະລຸນາປ້ອນຊື່ສິນຄ້າ!';
                // }
                // return errors;
              }}
              onSubmit={(values) => {
                if (duplicateMode) _duplicateProduct(values);
                else if (editMode) _editProduct(values);
                else _createProduct(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                /* and other goodies */
              }) => (
                <form className="row">
                  {/* UPLOAD IMAGE */}
                  <Col
                    md={3}
                    style={{
                      backgroundColor: "#f8f9fa",
                      padding: "20px",
                      display: "flex",
                      flexDirection: "column",

                      alignItems: "center",
                    }}
                  >
                    <input
                      type="file"
                      id="file-upload"
                      onChange={handleUpload}
                      hidden
                    />
                    <label>ຮູບໜ້າປົກ</label>
                    <label htmlFor="file-upload">
                      <div
                        style={{
                          background: "#fff",
                          height: "auto",
                          width: "100%",
                          border: "3px dashed " + COLOR_APP,
                          borderRadius: 8,
                          cursor: "pointer",
                          display: "flex",
                        }}
                      >
                        {file ? (
                          <ImageThumb image={file} />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              height: 150,
                              width: 150,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {!productData?.image ? (
                              <FontAwesomeIcon
                                icon={faImages}
                                style={{ color: COLOR_APP, fontSize: 80 }}
                              />
                            ) : (
                              <img
                                src={S3_URL + productData?.image}
                                style={{
                                  borderRadius: 8,
                                  height: 150,
                                  width: 150,
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </label>
                    {imageLoading ? (
                      <div className="progress" style={{ height: 20 }}>
                        <div
                          className="progress-bar"
                          role="progressbar"
                          // style={{
                          //   width: `${imageLoading}%`,
                          //   background: COLOR_APP,
                          // }}
                          aria-valuenow={imageLoading}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {/* {imageLoading}% */}
                        </div>
                      </div>
                    ) : (
                      <div style={{ height: 20 }} />
                    )}

                    {/* <UplaodManyImages /> */}
                    <div
                      className="editproductlist-left-subtitle"
                      style={{ marginTop: 24 }}
                    >
                      <span style={{ color: "#334155" }}>
                        ຮູບສິນຄ້າເພີ່ມເຕີ່ມ
                      </span>
                      (ສູງສຸດ {selectedImages.length}/9)
                    </div>

                    <div style={{ marginTop: 16 }}>
                      <div>
                        <input
                          style={{ display: "none" }}
                          ref={inputRef}
                          type="file"
                          multiple
                          accept="image/png, image/jpeg, image/jpg"
                          onChange={handleImageSelect}
                        />
                        <Button
                          style={{
                            background: COLOR_APP,
                            color: "#ffff",
                          }}
                          variant="outline-primary"
                          disabled={selectedImages.length >= 9}
                          title={"ເພີ່ມຮູບປະກອບ"}
                          onClick={handleClick}
                        >
                          + ເພີ່ມຮູບປະກອບ
                        </Button>
                      </div>
                      {msgError && (
                        <div style={{ color: "red", marginTop: "8px" }}>
                          {msgError}
                        </div>
                      )}
                    </div>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "16px",
                        justifyContent: "center",
                      }}
                    >
                      {selectedImages.map((image, index) => (
                        <div key={index} style={containerStyle}>
                          <div style={imageContainerStyle}>
                            <img
                              src={image}
                              alt={`Image ${index}`}
                              style={imageStyle}
                            />
                          </div>
                          <div style={deleteIconContainerStyle}>
                            <MdDelete
                              onClick={() => handleImageDelete(index)}
                              style={deleteIconStyle}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </Col>

                  <Col
                    md={9}
                    style={{ backgroundColor: "#e9ecef", padding: "20px" }}
                  >
                    <Form.Group>
                      <Form.Label>
                        ຊື່ສິນຄ້າ <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="productTitle"
                        onChange={(e) => {
                          setProductTitleEmpty(false);
                          setProductTitle(e?.target?.value ?? "");
                        }}
                        onBlur={handleBlur}
                        value={productTitle ?? ""}
                        placeholder="ຊື່ສິນຄ້າ..."
                        style={{
                          border: productTitleEmpty ? "solid 1px red" : "",
                        }}
                      />
                      {productTitleEmpty && (
                        <div style={{ color: "red", fontSize: 12 }}>
                          ກະລຸນາປ້ອນຊື່ສິນຄ້າ
                        </div>
                      )}
                    </Form.Group>

                    <Row>
                      <Col sm={6}>
                        <Row>
                          <Col>
                            <Form.Group>
                              <Form.Label>ຫົວຫນ່ວຍ</Form.Label>
                              <Form.Select
                                name="unit"
                                value={values.unit ?? ""}
                                onChange={(e) => onSelectUnit(e, setFieldValue)}
                                onBlur={handleBlur}
                                aria-label="select unit"
                              >
                                <option value="">ເລືອກຫົວໜ່ວຍ</option>
                                {/* ຂອງເກົ່າທີ່ພິມເອງ ແລະ ຍັງບໍ່ມີໃນລາຍການ — ຮັກສາໄວ້ບໍ່ໃຫ້ຫາຍ */}
                                {values.unit &&
                                  !unitDatas.find(
                                    (item) => item?.name === values.unit,
                                  ) && (
                                    <option value={values.unit}>
                                      {values.unit}
                                    </option>
                                  )}
                                {unitDatas.map((item) => (
                                  <option key={item?.id} value={item?.name}>
                                    {item?.name}
                                  </option>
                                ))}
                                <option
                                  value={ADD_UNIT_OPTION}
                                  style={{ borderTop: "1px solid #ccc" }}
                                >
                                  + ເພີ່ມຫົວໜ່ວຍ
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group>
                              <Form.Label>ສ່ວນຫຼຸດ</Form.Label>
                              <div style={{ display: "flex", gap: 8 }}>
                                <NumberFormat
                                  name="reduction"
                                  className="form-control"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.reduction ?? ""}
                                  placeholder="..."
                                  thousandSeparator={true}
                                  prefix={""}
                                  style={{ flex: 1, minWidth: 0 }}
                                />
                                <Form.Select
                                  aria-label="select reduction type"
                                  value={reductionType}
                                  onChange={(e) =>
                                    setReductionType(e.target.value)
                                  }
                                  style={{ flex: "0 0 90px", width: 90 }}
                                >
                                  <option value="PERCENT">%</option>
                                  <option value="AMOUNT">{currency}</option>
                                </Form.Select>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <Form.Group>
                          <Form.Label>ປະເພດສິນຄ້າ</Form.Label>
                          <Form.Select
                            value={categoryId}
                            onChange={(e) => onSelectCategories(e)}
                            aria-label="select category"
                          >
                            <option value="">ເລືອກປະເພດ</option>
                            {categoryDatas.map((item) => (
                              <option key={item?.id} value={item?.id}>
                                {item?.name}
                              </option>
                            ))}
                            <option
                              value={ADD_CATEGORY_OPTION}
                              style={{ borderTop: "1px solid #ccc" }}
                            >
                              + ເພີ່ມປະເພດສິນຄ້າ
                            </option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    {canUseSubCategory && (
                      <Form.Group className="mt-2">
                        <Form.Label>ປະເພດຍ່ອຍ</Form.Label>
                        <Form.Select
                          value={subCategoryId}
                          onChange={onSelectSubCategory}
                          disabled={!categoryId}
                          aria-label="select sub category"
                        >
                          <option value="">
                            {categoryId ? "ບໍ່ມີປະເພດຍ່ອຍ" : "ເລືອກປະເພດສິນຄ້າກ່ອນ"}
                          </option>
                          {subCategoryOptions.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                          <option
                            value={ADD_SUB_CATEGORY_OPTION}
                            style={{ borderTop: "1px solid #ccc" }}
                          >
                            + ເພີ່ມປະເພດຍ່ອຍ
                          </option>
                        </Form.Select>
                      </Form.Group>
                    )}

                    <Form.Group className="mt-2">
                      <Form.Label>ແບຣນ</Form.Label>
                      <Form.Select
                        value={brandId}
                        onChange={onSelectBrand}
                        aria-label="select brand"
                      >
                        <option value="">ບໍ່ມີແບຣນ</option>
                        {brandOptions.map((item) => (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                        <option
                          value={ADD_BRAND_OPTION}
                          style={{ borderTop: "1px solid #ccc" }}
                        >
                          + ເພີ່ມແບຣນ
                        </option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mt-2 mb-2">
                      <Form.Label>ສະກຸນເງິນ</Form.Label>
                      <ButtonGroup aria-label="Basic example">
                        <Button
                          style={{
                            background: currency == "ກີບ" ? COLOR_APP : "#eee",
                            color: currency == "ກີບ" ? "#ffff" : "#000",
                            width: 110,
                            marginLeft: 12,
                            borderWidth: 0,
                          }}
                          onClick={() => setCurrency("ກີບ")}
                        >
                          ກີບ
                        </Button>
                        <Button
                          style={{
                            background: currency == "ບາດ" ? COLOR_APP : "#eee",
                            color: currency == "ບາດ" ? "#ffff" : "#000",
                            width: 110,
                            marginLeft: 12,
                            borderWidth: 0,
                          }}
                          onClick={() => setCurrency("ບາດ")}
                        >
                          ບາດ
                        </Button>
                        <Button
                          style={{
                            background: currency == "ໂດລາ" ? COLOR_APP : "#eee",
                            color: currency == "ໂດລາ" ? "#ffff" : "#000",
                            width: 110,
                            marginLeft: 12,
                            borderWidth: 0,
                          }}
                          onClick={() => setCurrency("ໂດລາ")}
                        >
                          ໂດລາ
                        </Button>
                      </ButtonGroup>
                    </Form.Group>
                    <div
                      className="d-flex flex-wrap align-items-center mb-3"
                      style={{ gap: 32, marginLeft: "1rem" }}
                    >
                      <Form.Check
                        type="switch"
                        id="is-using-sale-page-switch"
                        name="isUsingSalePage"
                        label="ເປີດຂາຍເທິງ SalePage"
                        checked={isUsingSalePage}
                        onChange={(e) => {
                          setIsUsingSalePage(e.target.checked);
                          // ປິດຂາຍເທິງ SalePage → ລ້າງສິນຄ້າແນະນຳອອກນຳ
                          if (!e.target.checked) setIsRecommended(false);
                        }}
                      />
                      {isUsingSalePage && (
                        <Form.Check
                          type="checkbox"
                          id="is-recommended-product-checkbox"
                          name="isRecommended"
                          label="ສິນຄ້າແນະນຳ"
                          checked={isRecommended}
                          onChange={(e) => setIsRecommended(e.target.checked)}
                        />
                      )}
                    </div>
                    {/* Option */}

                    <Tabs
                      id="controlled-tab-example"
                      fill={width > 700 ? false : true}
                      activeKey={key}
                      onSelect={(k) => {
                        setKey(k);
                        if (k == "option") {
                          setIsSelectedOptions(true);
                        } else {
                          setIsSelectedOptions(false);
                        }
                      }}
                    >
                      <Tab eventKey="not_option" title="ບໍ່ໃຊ້ Option">
                        <div
                          className="col-12"
                          style={{
                            background: "white",
                            paddingBottom: 10,
                            paddingTop: 10,
                          }}
                        >
                          <div className="row">
                            <Form.Group
                              className={width > 700 ? "col-8" : "col-12"}
                            >
                              <Form.Label>
                                ລາຄາຕົ້ນທືນ ({currency}){" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <NumberFormat
                                name="stockOriginPriceLak"
                                className="form-control"
                                onChange={(e) =>
                                  setOriginPriceLak(
                                    e?.target?.value < 0
                                      ? -1 * e?.target?.value
                                      : (e?.target?.value ?? ""),
                                  )
                                }
                                onBlur={handleBlur}
                                value={stockOriginPriceLak ?? ""}
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                              />
                            </Form.Group>
                            <Form.Group
                              className={width > 700 ? "col-8" : "col-12"}
                            >
                              <Form.Label>
                                ລາຄາຂາຍ ({currency}){" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <NumberFormat
                                name="stockPriceLak"
                                className="form-control"
                                onChange={(e) =>
                                  setPriceLak(
                                    e?.target?.value < 0
                                      ? -1 * e?.target?.value
                                      : (e?.target?.value ?? ""),
                                  )
                                }
                                onBlur={handleBlur}
                                value={stockPriceLak ?? ""}
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                              />
                            </Form.Group>
                            <Form.Group
                              className={width > 700 ? "col-4" : "col-6"}
                            >
                              <Form.Label>
                                ຈໍານວນ <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="number"
                                name="stockAmount"
                                min={0}
                                onChange={(e) => {
                                  setIsProductAmount(false);
                                  setAmount(
                                    e?.target?.value < 0
                                      ? -1 * e?.target?.value
                                      : (e?.target?.value ?? ""),
                                  );
                                }}
                                onBlur={handleBlur}
                                value={stockAmount ?? ""}
                                placeholder="0"
                                style={{
                                  border: isProductAmount
                                    ? "solid 1px red"
                                    : "",
                                }}
                              />
                              {isProductAmount && (
                                <div style={{ color: "red", fontSize: 12 }}>
                                  ກະລຸນາປ້ອນຈໍານວນສິນຄ້າກ່ອນ
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          {/* CF-only: code-format selector + CF code. Hidden for Sale-page shops. */}
                          {isCF && (
                            <div className="d-flex row align-items-center mt-2">
                              <Form.Group
                                className={width > 700 ? "col-6" : "col-6"}
                              >
                                <Form.Label>ເລືອກຮູບແບບລະຫັດ</Form.Label>
                                <Form.Select
                                  value={genCodeType}
                                  onChange={(e) => onSelectedType(e)}
                                >
                                  <option value={"ONE_CODE"}>
                                    ແບບລະຫັດດ່ຽວ
                                  </option>
                                  <option value={"MULTI_CODE"}>
                                    ແບບຫຼາຍລະຫັດ
                                  </option>
                                </Form.Select>
                              </Form.Group>
                              <Form.Group
                                className={
                                  genCodeType == "MULTI_CODE"
                                    ? "col-6"
                                    : "col-4"
                                }
                              >
                                <Form.Label>
                                  ລະຫັດ CF{" "}
                                  <span style={{ color: "#6B7280" }}>(ບໍ່ບັງຄັບ)</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="codeGenNotOption"
                                  onChange={(e) => {
                                    setIsCodeGenNotOption(false);
                                    setCodeGenNotOption(e?.target?.value ?? "");
                                  }}
                                  value={codeGenNotOption ?? ""}
                                  placeholder="ລະຫັດ CF..."
                                  style={{
                                    border: isCodeGenNotOption
                                      ? "solid 1px red"
                                      : "",
                                    height: "45px",
                                  }}
                                />
                              </Form.Group>
                              <br />
                              {genCodeType == "MULTI_CODE" && (
                                <Form.Group
                                  className={width > 700 ? "col-2" : "col-4"}
                                >
                                  <Form.Label>ເລິ່ມຕົ້ນ</Form.Label>
                                  <Form.Control
                                    type="number"
                                    min={0}
                                    name="startCodeGen"
                                    onChange={(e) =>
                                      setStartCodeGen(
                                        e?.target?.value < 0
                                          ? -1 * e?.target?.value
                                          : (e?.target?.value ?? ""),
                                      )
                                    }
                                    value={startCodeGen ?? ""}
                                    placeholder="0"
                                  />
                                </Form.Group>
                              )}
                              {genCodeType == "MULTI_CODE" && (
                                <Form.Group
                                  className={width > 700 ? "col-2" : "col-4"}
                                >
                                  <Form.Label>ສິ້ນສຸດ</Form.Label>
                                  <Form.Control
                                    type="number"
                                    min={0}
                                    name="endCodeGen"
                                    onChange={(e) =>
                                      setEndCodeGen(
                                        e?.target?.value < 0
                                          ? -1 * e?.target?.value
                                          : (e?.target?.value ?? ""),
                                      )
                                    }
                                    value={endCodeGen ?? ""}
                                    placeholder="0"
                                  />
                                </Form.Group>
                              )}
                              <br />
                              {genCodeType == "MULTI_CODE" && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: 10,
                                  }}
                                >
                                  <div>
                                    <Button
                                      variant="outline-info"
                                      onClick={() => genMutiCode()}
                                    >
                                      ສ້າງລະຫັດ
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                          {codeGens.length > 0 &&
                            genCodeType === "MULTI_CODE" &&
                            codeGens?.map((item, index) => {
                              return (
                                <div
                                  key={index}
                                  className="d-flex row align-items-center"
                                >
                                  <Form.Group className="col-3">
                                    <Form.Label>ລະຫັດ CF</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="codeGenNotOption"
                                      value={item?.cfMessage ?? ""}
                                      placeholder="ລະຫັດ CF..."
                                      disabled
                                    />
                                  </Form.Group>
                                  <Form.Group className="col-3">
                                    <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="codeGenProductName"
                                      onChange={(e) => {
                                        let _codeGens = [...codeGens];
                                        _codeGens[index].name =
                                          e?.target?.value ?? "";
                                        setCodeGens(_codeGens);
                                      }}
                                      value={item?.name ?? ""}
                                      placeholder="ຊື່ສິນຄ້າ..."
                                    />
                                  </Form.Group>
                                  <Form.Group className="col-2">
                                    <Form.Label>ຈຳນວນ</Form.Label>
                                    <Form.Control
                                      type="number"
                                      min={0}
                                      name="amount"
                                      onChange={(e) => {
                                        let _codeGens = [...codeGens];
                                        _codeGens[index].amount =
                                          e?.target?.value < 0
                                            ? -1 * e?.target?.value
                                            : (e?.target?.value ?? "");
                                        setCodeGens(_codeGens);
                                      }}
                                      value={item?.amount ?? ""}
                                      placeholder="0"
                                    />
                                  </Form.Group>
                                  <Form.Group className="col-2">
                                    <Form.Label>
                                      ລາຄາຕົ້ນທືນ ({currency})
                                    </Form.Label>
                                    <NumberFormat
                                      name="originPrice"
                                      className="form-control"
                                      onChange={(e) => {
                                        let _codeGens = [...codeGens];
                                        _codeGens[index].originPrice =
                                          e?.target?.value < 0
                                            ? -1 * e?.target?.value
                                            : (e?.target?.value ?? "");
                                        setCodeGens(_codeGens);
                                      }}
                                      value={item?.originPrice ?? ""}
                                      placeholder="0"
                                      thousandSeparator={true}
                                      prefix={""}
                                    />
                                  </Form.Group>
                                  <Form.Group className="col-2">
                                    <Form.Label>
                                      ລາຄາຂາຍ ({currency})
                                    </Form.Label>
                                    <NumberFormat
                                      name="price"
                                      className="form-control"
                                      onChange={(e) => {
                                        let _codeGens = [...codeGens];
                                        _codeGens[index].price =
                                          e?.target?.value < 0
                                            ? -1 * e?.target?.value
                                            : (e?.target?.value ?? "");
                                        setCodeGens(_codeGens);
                                      }}
                                      value={item?.price ?? ""}
                                      placeholder="0"
                                      thousandSeparator={true}
                                      prefix={""}
                                    />
                                  </Form.Group>
                                </div>
                              );
                            })}
                        </div>
                      </Tab>
                      {/* ໂໝດແກ້ໄຂ ແກ້ໄດ້ເທື່ອລະ 1 ສິນຄ້າ ຈຶ່ງບໍ່ໃຫ້ gen option ໃໝ່ */}
                      <Tab
                        eventKey="option"
                        title="ໃຊ້ Option"
                        tabClassName={editMode ? "d-none" : undefined}
                      >
                        <div
                          className="col-12"
                          style={{
                            background: "white",
                            paddingBottom: 10,
                            paddingTop: 10,
                          }}
                        >
                          <div className="row">
                            <Form.Group
                              className={width > 700 ? "col-8" : "col-12"}
                            >
                              <Form.Label>
                                ລາຄາຕົ້ນທືນ ({currency}){" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <NumberFormat
                                name="stockOriginPriceLak"
                                className="form-control"
                                onChange={(e) =>
                                  setOriginPriceLak(
                                    e?.target?.value < 0
                                      ? -1 * e?.target?.value
                                      : (e?.target?.value ?? ""),
                                  )
                                }
                                onBlur={handleBlur}
                                value={stockOriginPriceLak ?? ""}
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                              />
                            </Form.Group>
                            <Form.Group
                              className={width > 700 ? "col-8" : "col-12"}
                            >
                              <Form.Label>
                                ລາຄາຂາຍ ({currency}){" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <NumberFormat
                                name="stockPriceLak"
                                className="form-control"
                                onChange={(e) =>
                                  setPriceLak(
                                    e?.target?.value < 0
                                      ? -1 * e?.target?.value
                                      : (e?.target?.value ?? ""),
                                  )
                                }
                                onBlur={handleBlur}
                                value={stockPriceLak ?? ""}
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                              />
                            </Form.Group>
                            <Form.Group
                              className={width > 700 ? "col-3" : "col-4"}
                            >
                              <Form.Label>
                                ຈໍານວນ <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="number"
                                name="stockAmount"
                                min={0}
                                onChange={(e) => {
                                  setIsProductAmount(false);
                                  setAmount(
                                    e?.target?.value < 0
                                      ? -1 * e?.target?.value
                                      : (e?.target?.value ?? ""),
                                  );
                                }}
                                onBlur={handleBlur}
                                value={stockAmount ?? ""}
                                placeholder="0"
                                style={{
                                  border: isProductAmount
                                    ? "solid 1px red"
                                    : "",
                                }}
                              />
                              {isProductAmount && (
                                <div style={{ color: "red", fontSize: 12 }}>
                                  ກະລຸນາປ້ອນຈໍານວນສິນຄ້າກ່ອນ
                                </div>
                              )}
                            </Form.Group>
                          </div>
                          <br />
                          {/* CF-only: product code prefix used to build CF codes per option. Hidden for Sale-page shops. */}
                          {isCF && (
                            <Form.Group>
                              <Form.Label>
                                ລະຫັດຂຶ້ນຕົ້ນຂອງສິນຄ້າ{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="codeGen"
                                value={codeGen}
                                onChange={(e) => {
                                  setIsCodeGenEmpty(false);
                                  setCodeGen(e?.target?.value ?? "");
                                }}
                                placeholder="ປ້ອນລະຫັດຂຶ້ນຕົ້ນຂອງສິນຄ້າ. ຕົວຢ່າງ: SP"
                              />
                              {isCodeGenEmpty && (
                                <div>
                                  <span style={{ color: "red", fontSize: 12 }}>
                                    ກະລຸນາປ້ອນລະຫັດຂຶ້ນຕົ້ນຂອງສິນຄ້າກ່ອນ
                                  </span>
                                </div>
                              )}
                            </Form.Group>
                          )}

                          {options.map((item, opIndex) => (
                            <div
                              controlId="formBasicCheckbox"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Form.Label
                                style={{
                                  color: COLOR_APP,
                                  fontSize: 18,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {item?.name}
                              </Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  flexWrap: "wrap",
                                  gap: "8px",
                                  alignItems: "flex-start",
                                }}
                              >
                                {item?.values
                                  ?.filter(
                                    (vl) => vl?.value && vl.value.trim() !== "",
                                  )
                                  .map((vl, childOpIndex) => {
                                    const safeValue =
                                      vl?.value || `option-${childOpIndex}`;
                                    const safeKey = `${safeValue}-${childOpIndex}`;

                                    return (
                                      <Form.Check
                                        key={safeKey}
                                        inline
                                        onChange={() =>
                                          _onSelectNewOption(item, vl)
                                        }
                                        type="checkbox"
                                        checked={_checkSelectedOptionVal(vl)}
                                        label={safeValue}
                                        style={{
                                          minWidth: "fit-content",
                                          marginRight: "0",
                                          marginBottom: "4px",
                                        }}
                                      />
                                    );
                                  })}
                              </div>
                            </div>
                          ))}

                          {selectedOptionsWhenGen.length > 0 &&
                            selectedOptionsWhenGen?.map((item, index) => (
                              <div
                                key={index}
                                className="col-12"
                                style={{
                                  border: "1px solid #eee",
                                  background: "#fff",
                                  borderRadius: 5,
                                  marginBottom: 4,
                                }}
                              >
                                <h5>
                                  {item?.key?.name
                                    ? item?.key?.name + " " + item?.key?.value
                                    : "-"}
                                </h5>
                                {item?.value?.map((item2, index2) => {
                                  return (
                                    <div
                                      key={index2}
                                      className="row"
                                      style={{
                                        background: "white",
                                        marginBottom: 8,
                                      }}
                                    >
                                      {isCF && (
                                        <div className="col-2">
                                          <Form.Group>
                                            <Form.Label>ລະຫັດ CF</Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="cfMessage"
                                              value={item2?.cfMessage}
                                              placeholder=""
                                              disabled
                                            />
                                          </Form.Group>
                                        </div>
                                      )}
                                      <div className="col-3">
                                        <Form.Group>
                                          <Form.Label>{item2?.name}</Form.Label>
                                          <Form.Control
                                            type="text"
                                            name="option"
                                            value={item2?.value}
                                            placeholder="0"
                                            disabled
                                          />
                                        </Form.Group>
                                      </div>
                                      <div className="col-2">
                                        <Form.Group>
                                          <Form.Label>ຈຳນວນ</Form.Label>
                                          <Form.Control
                                            type="number"
                                            name="amount"
                                            min={0}
                                            value={item2?.amount}
                                            onChange={(e) => {
                                              let _data = [
                                                ...selectedOptionsWhenGen,
                                              ];
                                              _data[index].value[
                                                index2
                                              ].amount =
                                                e?.target?.value < 0
                                                  ? -1 * e?.target?.value
                                                  : e?.target?.value;
                                              setSelectedOptionsWhenGen(_data);
                                            }}
                                            placeholder="0"
                                          />
                                        </Form.Group>
                                      </div>
                                      <div className="col-2">
                                        <Form.Group>
                                          <Form.Label>
                                            ລາຄາຕົ້ນທືນ ({currency})
                                          </Form.Label>
                                          <NumberFormat
                                            name="originPrice"
                                            className="form-control"
                                            onChange={(e) => {
                                              let _data = [
                                                ...selectedOptionsWhenGen,
                                              ];
                                              _data[index].value[
                                                index2
                                              ].originPrice =
                                                e?.target?.value < 0
                                                  ? -1 * e?.target?.value
                                                  : e?.target?.value;
                                              setSelectedOptionsWhenGen(_data);
                                            }}
                                            value={item2?.originPrice ?? ""}
                                            placeholder="0"
                                            thousandSeparator={true}
                                            prefix={""}
                                          />
                                        </Form.Group>
                                      </div>
                                      <div className="col-2">
                                        <Form.Group>
                                          <Form.Label>
                                            ລາຄາຂາຍ ({currency})
                                          </Form.Label>
                                          <NumberFormat
                                            name="price"
                                            className="form-control"
                                            onChange={(e) => {
                                              let _data = [
                                                ...selectedOptionsWhenGen,
                                              ];
                                              _data[index].value[index2].price =
                                                e?.target?.value < 0
                                                  ? -1 * e?.target?.value
                                                  : e?.target?.value;
                                              setSelectedOptionsWhenGen(_data);
                                            }}
                                            value={item2?.price ?? ""}
                                            placeholder="0"
                                            thousandSeparator={true}
                                            prefix={""}
                                          />
                                        </Form.Group>
                                      </div>
                                      <div className="col-1">
                                        <Form.Group>
                                          <div>
                                            <Form.Label
                                              style={{ color: "white" }}
                                            >
                                              Action
                                            </Form.Label>
                                          </div>
                                          <div>
                                            <Form.Label>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                style={{
                                                  color: "red",
                                                  cursor: "pointer",
                                                }}
                                                onClick={async () => {
                                                  _removeOptionProduct(
                                                    item,
                                                    index,
                                                    index2,
                                                  );
                                                }}
                                              />
                                            </Form.Label>
                                          </div>
                                        </Form.Group>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ))}

                          <br />
                          <Button
                            className="btn btn-app hoverme mr-2"
                            variant="outline-info"
                            onClick={() => onGenOption()}
                          >
                            ສ້າງລະຫັດ
                          </Button>
                          <Button
                            // onClick={() => onAddOption()}
                            onClick={() =>
                              history.push("/settings-option-value")
                            }
                            variant="outline-success"
                          >
                            ເພີ່ມຕົວເລືອກ +
                          </Button>
                          <br />
                        </div>
                      </Tab>
                    </Tabs>

                    <br></br>

                    <div>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={
                          showDetail
                            ? "ປິດສະແດງ ໃສ່ລາຍລະອຽດເພີ່ມເຕີມ"
                            : "ສະແດງ ໃສ່ລາຍລະອຽດເພີ່ມເຕີມ"
                        }
                        checked={showDetail}
                        onChange={() => setShowDetail(!showDetail)}
                        style={{ marginBottom: "1rem", marginLeft: "1rem" }}
                      />

                      {showDetail && (
                        <>
                          <hr />
                          <div className="p-2 bg-white mt-4">
                            <h4>ຄຸນລັກສະນະສົມບັດສິນຄ້າ</h4>
                            <br />
                            <Button
                              variant="outline-info"
                              onClick={() => setShowModal(true)}
                              className="w-100"
                            >
                              + ເພີ່ມຄຸນນະສົມບັດ
                            </Button>

                            <div className="mt-4">
                              {properties.map((item, index) => (
                                <Card
                                  key={index}
                                  className="mb-2 position-relative shadow-sm"
                                >
                                  <Card.Body>
                                    <Card.Title>{item.title}</Card.Title>
                                    <Card.Text>{item.detail}</Card.Text>
                                  </Card.Body>
                                  <Button
                                    variant="danger"
                                    onClick={() => handleDelete(index)}
                                    style={deleteButtonStyle}
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </Button>
                                </Card>
                              ))}
                            </div>
                          </div>

                          <hr />

                          <Container className="text-start">
                            <style>{`
        .card-wrapper {
          display: flex;
          align-items: flex-start; /* Align items to the top */
          overflow: hidden;
          position: relative;
        }

        .card-img-wrapper {
          flex: 0 0 150px;
          max-width: 150px;
        }

        .card-img-wrapper img {
          width: 100%;
          height: auto;
          object-fit: cover;
          height: 150px; /* Set a fixed height for images */
        }

        .card-body-wrapper {
          flex: 1;
          padding-left: 15px;
          position: relative;
        }

        .card-title-wrapper {
          overflow-y: auto;
          max-height: 8rem; /* Adjust the height as needed */
          padding-right: 5px; /* Space for scrollbar */
        }

        /* Optional: Hide scrollbar for webkit browsers */
        .card-title-wrapper::-webkit-scrollbar {
          width: 0px;
          background: transparent; /* Optional: Make scrollbar background transparent */
        }

        .remove-button {
          position: absolute;
          top: 10px;
          right: 10px;
        }
      `}</style>
                            <Row className="justify-content-start">
                              {entries.map((entry, index) => (
                                <Col
                                  md={12}
                                  className="mb-3"
                                  key={entry.id || index}
                                >
                                  <Card className="position-relative shadow-sm h-100">
                                    <div className="card-wrapper">
                                      {entry.imagePreview && (
                                        <div className="card-img-wrapper">
                                          <Card.Img
                                            src={entry.imagePreview || null}
                                            alt={entry.alt || null}
                                          />
                                        </div>
                                      )}
                                      <div className="card-body-wrapper">
                                        <Button
                                          variant="danger"
                                          className="remove-button p-0 rounded-circle"
                                          onClick={() =>
                                            handleRemoveCard(index)
                                          }
                                          aria-label={`Remove card ${index + 1}`}
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </Button>
                                        <Card.Body className="d-flex flex-column">
                                          <div className="card-title-wrapper flex-grow-1">
                                            <div
                                              as="div"
                                              style={{ whiteSpace: "normal" }}
                                              dangerouslySetInnerHTML={{
                                                __html: entry.title || "",
                                              }}
                                            />
                                          </div>
                                        </Card.Body>
                                      </div>
                                    </div>
                                  </Card>
                                </Col>
                              ))}
                            </Row>
                          </Container>

                          <br></br>
                          <div className="bg-white p-4">
                            <h3>ເພີ່ມລາຍລະອຽດຂອງສິນຄ້າ</h3>
                            <TextEditor
                              data={editorData}
                              onEditorChange={handleEditorChange}
                              placeholder="ເພີ່ມລາຍລະອຽດສິນຄ້າ..."
                              style={{ borderColor: error ? "red" : "black" }} // Apply red border if there's an error
                            />
                            {error && (
                              <p style={{ color: "red" }}>
                                ກະລຸນາ ປ້ອນຂໍ້ຄວາມຫລືຮູບກ່ອນ !
                              </p>
                            )}
                            <br />

                            <Form.Group controlId="formFile" className="mb-3">
                              <div style={styles.container}>
                                {imagePreview ? (
                                  <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={styles.imagePreview}
                                  />
                                ) : (
                                  <p>ເພີ່ມຮູບພາບລາຍລະອຽດສິນຄ້າ</p>
                                )}
                                <Form.Control
                                  type="file"
                                  accept="image/*"
                                  onChange={handleImage}
                                  style={styles.fileInput}
                                />
                              </div>
                            </Form.Group>
                            <Button
                              variant="outline-info"
                              className="w-100"
                              onClick={handleButtonClick}
                            >
                              ບັນທຶກລາຍລະອຽດສິນຄ້າ
                            </Button>
                          </div>
                        </>
                      )}
                    </div>

                    <div
                      style={{
                        position: "fixed",
                        bottom: 0,
                        right: 0,
                        zIndex: 90,
                        width: "fit",
                        padding: 10,
                        display: "flex",
                        gap: 5,
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        style={{
                          border: "1px solid " + COLOR_TEXT,
                          color: COLOR_TEXT,
                          width: width > 700 ? 200 : "auto",
                          background: "#fff",
                        }}
                        onClick={() => history.goBack()}
                      >
                        ຍົກເລີກ
                      </Button>
                      <Button
                        //* isLoading ຄຸມທັງຕອນເພີ່ມ ແລະ ຕອນແກ້ໄຂ (ຕັ້ງໃນ
                        //* _createProduct / _editProduct) ກັນກົດຊ້ຳລະຫວ່າງບັນທຶກ
                        disabled={
                          isLoading || (imageLoading > 0 && imageLoading < 100)
                        }
                        style={{
                          background: COLOR_APP,
                          color: "#ffff",
                          width: width > 700 ? 200 : "auto",
                          marginLeft: 12,
                        }}
                        onClick={() => handleSubmit()}
                      >
                        {isLoading ||
                        createStockLoading ||
                        createProductAndStocksLoading ||
                        updateStockV2Loading ? (
                          <>
                            <Spinner animation="border" size="sm" />{" "}
                            ກຳລັງບັນທຶກ...
                          </>
                        ) : (
                          <>
                            <FaCheck /> ບັນທຶກ
                          </>
                        )}
                      </Button>
                    </div>
                  </Col>

                  {/* ເພີ່ມຫົວໜ່ວຍໃໝ່ໄດ້ຈາກໜ້ານີ້ເລີຍ — ວາງໄວ້ໃນນີ້ເພື່ອໃຊ້ setFieldValue ຂອງ Formik */}
                  <Modal show={showAddUnitModal} onHide={onCloseAddUnitModal}>
                    <Modal.Header closeButton>
                      <Modal.Title>ເພີ່ມຫົວໜ່ວຍ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group>
                        <Form.Label>
                          ຊື່ຫົວໜ່ວຍ <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="ຕົວຢ່າງ: ຜືນ, ຄູ່, ອັນ..."
                          value={newUnitName}
                          onChange={(e) => setNewUnitName(e.target.value)}
                        />
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        type="button"
                        onClick={onCloseAddUnitModal}
                        disabled={createUnitLoading}
                      >
                        ຍົກເລີກ
                      </Button>
                      <Button
                        variant="primary"
                        type="button"
                        onClick={() => onCreateUnit(setFieldValue)}
                        disabled={createUnitLoading}
                      >
                        {createUnitLoading ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          "ບັນທຶກ"
                        )}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </form>
              )}
            </Formik>
          )}
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ເພີ່ມຄຸນລັກສະນະພິເສດສິນຄ້າ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>ຫົວຂໍ້</Form.Label>
              <Form.Control
                type="text"
                placeholder="ເພີ່ມຄຸນລັກສະນະທີ່ທ່ານຕ້ອງການ..."
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                // style={{ borderColor: error ? 'red' : 'black' }}
              />
              {errorPropertie && (
                <p style={{ color: "red" }}>ກະລຸນາ ເພີ່ມຄຸນລັກສະນະ !</p>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>ລາຍລະອຽດ</Form.Label>
              <Form.Control
                type="text"
                placeholder="ເພີ່ມລາຍລະອຽດ..."
                value={detail}
                onChange={(e) => setDetail(e.target.value)}
                // style={{ borderColor: error ? 'red' : 'black' }}
              />
              {errorPropertie && (
                <p style={{ color: "red" }}>ກະລຸນາ ເພີ່ມລາຍລະອຽດ !</p>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            ຍົກເລີກ
          </Button>
          <Button variant="primary" onClick={handleAddDetail}>
            ບັນທຶກ
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ເພີ່ມປະເພດສິນຄ້າໃໝ່ໄດ້ຈາກໜ້ານີ້ເລີຍ */}
      <Modal show={showAddSubCategoryModal} onHide={onCloseAddSubCategoryModal}>
        <Modal.Header closeButton>
          <Modal.Title>ເພີ່ມປະເພດຍ່ອຍ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              ຊື່ປະເພດຍ່ອຍ <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="ຕົວຢ່າງ: ເສື້ອຍືດ, ເສື້ອເຊີດ..."
              value={newSubCategoryName}
              onChange={(e) => setNewSubCategoryName(e.target.value)}
            />
            <Form.Text muted>ຢູ່ພາຍໃຕ້ປະເພດ: {categoriesName}</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            type="button"
            onClick={onCloseAddSubCategoryModal}
            disabled={createSubCategoryLoading}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={onCreateSubCategory}
            disabled={createSubCategoryLoading}
          >
            {createSubCategoryLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              "ບັນທຶກ"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAddBrandModal} onHide={onCloseAddBrandModal}>
        <Modal.Header closeButton>
          <Modal.Title>ເພີ່ມແບຣນ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              ຊື່ແບຣນ <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="ຕົວຢ່າງ: Nike, Adidas..."
              value={newBrandName}
              onChange={(e) => setNewBrandName(e.target.value)}
            />
            <Form.Text muted>
              {categoriesName
                ? `ແບຣນນີ້ຈະຢູ່ໃນປະເພດ: ${categoriesName}`
                : "ບໍ່ໄດ້ເລືອກປະເພດ — ໃຊ້ໄດ້ກັບທຸກປະເພດ"}
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            type="button"
            onClick={onCloseAddBrandModal}
            disabled={createBrandLoading}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={onCreateBrand}
            disabled={createBrandLoading}
          >
            {createBrandLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              "ບັນທຶກ"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showAddCategoryModal} onHide={onCloseAddCategoryModal}>
        <Modal.Header closeButton>
          <Modal.Title>ເພີ່ມປະເພດສິນຄ້າ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                ຊື່ປະເພດສິນຄ້າ <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="ຕົວຢ່າງ: ເສື້ອຜ້າ, ເກີບ, ກະເປົາ..."
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>ລາຍລະອຽດ</Form.Label>
              <Form.Control
                type="text"
                placeholder="ເພີ່ມລາຍລະອຽດ..."
                value={newCategoryNote}
                onChange={(e) => setNewCategoryNote(e.target.value)}
              />
            </Form.Group>
            <CategorySortField
              name="sort"
              value={newCategorySort}
              onChange={(e) => setNewCategorySort(e.target.value)}
              usedSorts={usedSorts}
              isTaken={isTaken}
              loading={loadingSorts}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onCloseAddCategoryModal}
            disabled={createCategoryLoading}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            onClick={onCreateCategory}
            disabled={createCategoryLoading}
          >
            {createCategoryLoading ? (
              <Spinner size="sm" animation="border" />
            ) : (
              "ບັນທຶກ"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProductAdd;

const styles = {
  container: {
    position: "relative",
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f9fa",
    border: "1px solid #ced4da",
    borderRadius: "4px",
    overflow: "hidden", // Ensure content doesn't overflow
  },
  fileInput: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: 0,
    cursor: "pointer",
  },
  icon: {
    fontSize: "24px",
    color: "#007bff",
    pointerEvents: "none", // Ensures the icon doesn't block clicks
  },
  imagePreview: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};

const containerStyle = {
  position: "relative",
  // width: '150px', /* Fixed width */
  // height: '150px', /* Fixed height */
  marginBottom: "16px",
  border: "1px solid #E2E8F0",
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 0 8px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.2s",
  cursor: "pointer",
};

const imageContainerStyle = {
  height: "120px",
  overflow: "hidden",
};

const imageStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  transition: "transform 0.3s",
};

const deleteIconContainerStyle = {
  position: "absolute",
  top: "8px",
  right: "8px",
  background: "rgba(255, 255, 255, 0.8)",
  borderRadius: "50%",
  padding: "4px",
};

const deleteIconStyle = {
  cursor: "pointer",
  color: "red",
  fontSize: "20px",
};

const deleteButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "-10px",
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0",
};
const imgStyle = {
  width: "100%",
  height: "100px", // Set a fixed height for all images
  objectFit: "cover", // Adjust this as needed (e.g., 'contain')
};

const iconStyle = {
  fontSize: "30px",
  cursor: "pointer",
  position: "absolute",
  top: "10px",
  right: "10px",
  color: "red",
  // backgroundColor: 'white',
  borderRadius: "50%",
  padding: "5px",
};
// Hover effect for the container
const hoverEffect = {
  containerStyle: {
    ...containerStyle,
    ":hover": {
      transform: "scale(1.05)",
    },
  },
  imageStyle: {
    ...imageStyle,
    ":hover": {
      transform: "scale(1.1)",
    },
  },
};

const stylesmobile = {
  card: {
    position: "relative",
  },
  cardImg: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "10px",
    margin: "10px",
  },
  cardBody: {
    overflowY: "auto",
    width: "200px",
    wordWrap: "break-word",
    marginRight: "10px",
  },
  button: {
    position: "absolute",
    top: "10px",
    right: "-10px",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.3s",
    zIndex: 1, // Ensure the button is above other content
  },
};
const cardStyle = {
  border: "none", // Remove border shadow
  borderRadius: "0.25rem", // Optional: Adjust border radius if needed
  position: "relative", // Required for positioning the delete button
};
